import React from "react";
import { CheckIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { Countdown } from "../Countdown";
import { images } from "../../data/content";
const includes = ["Six premium educational volumes", "Five exclusive bonuses", "Immediate digital access", "Lifetime access to the purchased materials", "Seven-day money-back guarantee"];
const mantra = ["Start with the tooth.", "Understand its limitations.", "Evaluate your options.", "Build your restorative roadmap."];
export function FinalCTA() {
  return <section className="w-full bg-ink px-4 py-16 sm:py-20" data-id="element-117" data-mp="3hskrsbd6thw9">
      <div className="mx-auto max-w-3xl text-center" data-id="element-118" data-mp="33vxvmat26vre">
        <h2 className="font-display text-[28px] font-black leading-tight text-white sm:text-4xl" data-id="element-119" data-mp="33x8v3yfh1hcp">
          Are You Ready to Organize Your Next Post-Endodontic Restorative Plan?
        </h2>
        <p className="mt-5 text-[17px] leading-relaxed text-mist" data-id="element-120" data-mp="121q71wfwj72z">
          You don’t need another collection of disconnected concepts. You need a structured way to bring those concepts together when evaluating an endodontically treated tooth.
        </p>

        <ul className="mx-auto mt-8 max-w-md space-y-2 text-left" data-id="element-121" data-mp="l8h9yqbikr8z">
          {mantra.map((m, i) => <li key={m} className="flex items-center gap-3 rounded-xl bg-navy px-4 py-3" data-id="element-122" data-mp="yznjzgcf67a4" data-mpi={i}>
              <span className="font-display text-lg font-black text-brand" data-id="element-123" data-mp="v0eq8bhdq9ek">{i + 1}</span>
              <span className="font-display text-lg font-extrabold text-white" data-id="element-124" data-mp="78zl6ay7xdzm">{m}</span>
            </li>)}
        </ul>

        <img src={images.mockup} alt="Post-Endodontic Restoration Blueprint package" className="mx-auto mt-10 w-full max-w-xl" loading="lazy" data-id="element-125" data-mp="2c953nmeyie7" />

        <p className="mt-6 font-display text-sm font-black uppercase tracking-wider text-brand" data-id="element-126" data-mp="bbmfqjm9xd0i">Only</p>
        <p className="font-display text-7xl font-black leading-none text-cta" data-id="element-127" data-mp="1rpco42kfenfy">$27 <span className="text-2xl text-white" data-id="element-128" data-mp="1rrfkd4c69ct4">USD</span></p>

        <ul className="mx-auto mt-6 max-w-md space-y-2 text-left" data-id="element-129" data-mp="1mpq9booy8z51">
          {includes.map(i => <li key={i} className="flex gap-2.5" data-id="element-130" data-mp="kcby95wnd0up">
              <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-ok" strokeWidth={3} aria-hidden data-id="element-131" data-mp="pby8d6h6i0za" />
              <span className="text-[15px] text-white" data-id="element-132" data-mp="te1ls0nerfn7">{i}</span>
            </li>)}
        </ul>

        <div className="mt-10 flex flex-col items-center gap-6" data-id="element-133" data-mp="ycmms2ahi3cp">
          <CTAButton label="I want Post-Endodontic Restoration Blueprint™" pulse data-id="element-134" data-mp="yasblfp0lplt" />
          <Countdown data-id="element-135" data-mp="1o6tpw861buu" />
        </div>
      </div>
    </section>;
}